import { useEffect } from 'react';
import '../../../../css/notification.less';
import type { Notification as NotificationType } from '../../types/notification';
import { getItem, removeItem } from '../../utils/storage';
import Notification from './Notification';
import { useNotificationDispatch, useNotifications } from './NotificationProvider';

const NotificationList = () => {
    const notifications = useNotifications();
    const dispatchNotification = useNotificationDispatch();

    // Only ever show a maximum of 5
    const mostRecentNotifications = notifications.slice(-5);

    useEffect(() => {
        // This notification is added to storage without an ID
        const startupNotification = getItem<Omit<NotificationType, 'id'>>('startup-notification');

        if (startupNotification) {
            removeItem('startup-notification');
            dispatchNotification({
                type: 'addNotification',
                payload: startupNotification,
            });
        }
    }, [dispatchNotification]);

    return (
        <div className="toast-notifications">
            {mostRecentNotifications.map((notification) => (
                <Notification
                    key={notification.id}
                    notification={notification}
                    dispatchNotification={dispatchNotification}
                />
            ))}
        </div>
    );
};

export default NotificationList;
